// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-emoji {\n  -webkit-box-shadow: 0 0 4px 0 rgba(173, 185, 193, 0.5);\n          box-shadow: 0 0 4px 0 rgba(173, 185, 193, 0.5);\n}\n.x-emoji .ant-dropdown-menu-item-disabled ant-dropdown-menu-item {\n  cursor: pointer;\n}\n.x-emoji .ant-dropdown-menu-item {\n  padding: 5px;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n", ""]);
// Exports
module.exports = exports;
